var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentVisible)?_c('div',{staticClass:"machine-counter-wrapper not-ready"},[_c('hr'),_vm._v(" Noch "+_vm._s(_vm.numberToWord[_vm.pagesToFinish])),_c('br'),_vm._v("bis zum Zwischenergebnis ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }